import * as React from 'react';
import {
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import * as XLSX from 'xlsx';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { LoadingWidget } from '../../widgets';
import { LoadingButton } from '@mui/lab';
import { GREEN_COLOR } from '../../constants/ColorsConst';
import { VisuallyHiddenInput } from '../usuario/usuarios/components/SettingsUsuarios';

const ReportesView = () => {
  const [loading, setLoading] = React.useState(false);

  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [namefile, setNamefile] = React.useState(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.log('No file selected.');
      return;
    }
    setNamefile(file.name);

    setLoading(true);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        const columnKey = Object.keys(data[0]);

        const filteredData = data.filter(
          (row) =>
            row[columnKey[2]] !== undefined &&
            row[columnKey[2]] !== null &&
            row[columnKey[2]] !== '',
        );

        const cols = Object.keys(filteredData[0]).map((key) => ({
          name: key,
          // label: key,
          // options: {
          //   filter: true,
          //   sort: true,
          //   customBodyRender: (value, tableMeta, updateValue) => {
          //     return (
          //       <Box
          //         width={
          //           String(value).length > 100
          //             ? 750
          //             : String(value).length > 20
          //             ? 550
          //             : String(value).length < 10
          //             ? 100
          //             : 200
          //         }
          //       >
          //         <Typography variant="body1" align="start">
          //           {value}
          //         </Typography>
          //       </Box>
          //     );
          //   },
          // },
        }));

        setColumns(cols);
        setRows(filteredData);

        setLoading(false);
        e.target.value = '';
      } catch (err) {
        console.error('Error reading file:', err);
        e.target.value = '';
      }
    };
    reader.onerror = (err) => console.error('Error reading file:', err);
    reader.readAsBinaryString(file);
  };

  // const options = {
  //   filterType: 'dropdown',
  //   responsive: 'standard',
  //   setTableProps: () => {
  //     return {
  //       padding: 'none',
  //       size: 'small',
  //     };
  //   },
  //   rowsPerPage: rows.length,
  //   rowsPerPageOptions: [50, 100, 200, rows.length],
  //   print: false,
  //   download: false,
  //   textLabels,
  //   selectableRowsHideCheckboxes: true,
  //   expandableRows: true,
  //   renderExpandableRow: (rowData, rowMeta) => {
  //     // const data = getDataStore(rowData[0]);
  //     // return <ExpandedSeccionesComponent data={data} rowData={rowData} />;
  //   },
  // };

  function tables() {
    return (
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.name}>
                  <Typography
                    variant="body1"
                    color="initial"
                    fontWeight="bold"
                    align="center"
                  >
                    {column.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                  <TableCell key={column.name}>
                    <Stack alignItems="center" justifyContent="center">
                      <Typography
                        variant="body1"
                        color="initial"
                        align="center"
                      >
                        {row[column.name]}
                      </Typography>
                    </Stack>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingButton
          loading={loading}
          sx={{
            backgroundColor: GREEN_COLOR,
          }}
          component="label"
          variant="contained"
          onChange={handleFileUpload}
          startIcon={<CloudUploadIcon />}
        >
          {loading ? 'Subiendo Excel...' : namefile ?? 'Subir documento Excel'}
          <VisuallyHiddenInput type="file" accept=".xlsx, .xls" />
        </LoadingButton>
      </Grid>
      <Grid item md={12}>
        <LoadingWidget isLoading={loading} />
        {/* <MUIDataTable
          title={`Listado ${rows.length} registros`}
          data={rows}
          columns={columns}
          options={options}
        /> */}
        {tables()}
      </Grid>
    </Grid>
  );
};

export default ReportesView;
